import { PUBLISH, TRACKING } from 'constants/analytics'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const sendEvents = (body: {
  context: {
    readonly traits: {
      readonly nabu_id: any
    }
  }
  device: 'WEB'
  events: any
  platform: 'EXCHANGE'
}) =>
  fetchApi({
    auth: true,
    body,
    method: 'POST',
    url: getApiUrl(`events/${PUBLISH}`)
  })

export const getTracking = () =>
  fetchApi({
    auth: true,
    url: getApiUrl(`events/${TRACKING}`)
  })
